import React from 'react';
import { motion } from 'framer-motion';

const FloatingMenuButton = ({ onClick, isOpen }) => {
  return (
    <motion.button
      className={`
        fixed bottom-6 left-6 z-[9999] w-16 h-16 rounded-full shadow-2xl 
        font-semibold text-white transition-all duration-300 
        focus:outline-none focus:ring-4 focus:ring-opacity-50
        ${isOpen 
          ? 'bg-gray-600 hover:bg-gray-700 focus:ring-gray-300' 
          : 'bg-green-600 hover:bg-green-700 focus:ring-green-300'
        }
        lg:block
      `}
      onClick={onClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ type: "spring", stiffness: 400, damping: 17 }}
      style={{
        position: 'fixed',
        bottom: '24px',
        left: '24px',
        zIndex: 9999
      }}
    >
      <div className="flex flex-col items-center justify-center space-y-1">
        {/* Hamburger Icon */}
        <div className="flex flex-col space-y-1">
          <motion.div
            className="w-4 h-0.5 bg-white rounded"
            animate={{
              rotate: isOpen ? 45 : 0,
              y: isOpen ? 4 : 0,
            }}
            transition={{ duration: 0.3 }}
          />
          <motion.div
            className="w-4 h-0.5 bg-white rounded"
            animate={{
              opacity: isOpen ? 0 : 1,
            }}
            transition={{ duration: 0.3 }}
          />
          <motion.div
            className="w-4 h-0.5 bg-white rounded"
            animate={{
              rotate: isOpen ? -45 : 0,
              y: isOpen ? -4 : 0,
            }}
            transition={{ duration: 0.3 }}
          />
        </div>
        {/* Text */}
        <span className="text-xs font-bold tracking-wide mt-1">
          {isOpen ? 'CLOSE' : 'MENU'}
        </span>
      </div>
    </motion.button>
  );
};

export default FloatingMenuButton;